import * as React from "react";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { SelectFromModalButton } from "src/components/SelectFromModalButton";
import { ZSidLabel } from "src/types";

import { catalogsLoader } from "../apiCatalog";
import { CatalogFilters, ZCatalog } from "../ZCatalog";
import { SelectCatalogModal } from "./SelectCatalogModal";

export type PropsSelectCatalog = {
  value?: ZSidLabel | null;
  onChange?(newValue?: ZSidLabel | null): void;
  disabled?: boolean;
};

export const SelectCatalog: React.FC<PropsSelectCatalog> = (props) => {
  const { disabled, value, onChange } = props;
  const options: ZSidLabel[] = value ? [value] : [];
  const onChangeLocal = (newValue: ZSidLabel[] | null) => {
    onChange?.(newValue?.[0] ?? null);
  };
  const [tableStore, setTableStore] = React.useState<
    RtStore<ZCatalog, CatalogFilters> | undefined
  >();
  const createStore = () => {
    const store = new RtStore({
      rowKey: "id",
      loader: catalogsLoader(),
      selectionType: "radio",
      keepSelected: true,
      defaultRequest: { pageSize: 20 },
    });
    store.setSelectedKeys(options.map(({ id }) => id));
    setTableStore(store);
  };

  return (
    <SelectFromModalButton
      disabled={disabled}
      options={options}
      onChange={onChangeLocal}
      onOpen={createStore}
    >
      <SelectCatalogModal
        tableStore={tableStore}
        srcSelected={options}
        close={() => setTableStore(undefined)}
        onApply={onChangeLocal}
      />
    </SelectFromModalButton>
  );
};
